/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_ExportsInputs */

const en_svchip_exports = /** @type {(inputs: Svchip_ExportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exports`)
};

const ar_svchip_exports = /** @type {(inputs: Svchip_ExportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التصديرات`)
};

const bn_svchip_exports = /** @type {(inputs: Svchip_ExportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এক্সপোর্ট`)
};

const de_svchip_exports = /** @type {(inputs: Svchip_ExportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporte`)
};

const es_svchip_exports = /** @type {(inputs: Svchip_ExportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportaciones`)
};

const fr_svchip_exports = /** @type {(inputs: Svchip_ExportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportations`)
};

const pt_svchip_exports = /** @type {(inputs: Svchip_ExportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportações`)
};

const zh_svchip_exports = /** @type {(inputs: Svchip_ExportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口`)
};

const tr_svchip_exports = /** @type {(inputs: Svchip_ExportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dışa aktarmalar`)
};

const ru_svchip_exports = /** @type {(inputs: Svchip_ExportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт`)
};

const pl_svchip_exports = /** @type {(inputs: Svchip_ExportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksport`)
};

/**
* | output |
* | --- |
* | "Exports" |
*
* @param {Svchip_ExportsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_exports = /** @type {((inputs?: Svchip_ExportsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_ExportsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_exports(inputs)
	if (locale === "bn") return bn_svchip_exports(inputs)
	if (locale === "de") return de_svchip_exports(inputs)
	if (locale === "es") return es_svchip_exports(inputs)
	if (locale === "fr") return fr_svchip_exports(inputs)
	if (locale === "pt") return pt_svchip_exports(inputs)
	if (locale === "zh") return zh_svchip_exports(inputs)
	if (locale === "tr") return tr_svchip_exports(inputs)
	if (locale === "ru") return ru_svchip_exports(inputs)
	if (locale === "pl") return pl_svchip_exports(inputs)
	return en_svchip_exports(inputs)
});